import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { AppSettingsService } from '../appsettings/appsettings.service';

@Injectable({
  providedIn: 'root'
})
export class DelegationService {
	readonly rootUrl = environment.ProNetApiRootUrl; // 'http://localhost:3001';
	
  constructor(private httpClient: HttpClient, env: AppSettingsService) { 
		this.rootUrl = env.config.ProNetApiRootUrl; }

  getDelegation(): Observable<any> {
		console.log('Getting Delegations for current user')
		const headers = new HttpHeaders(
			{
				'No-Auth':'False',
				'Content-Type': 'application/json',
			});		
		return this.httpClient.get(`${this.rootUrl}/api/delegation`, {headers: headers, withCredentials:true});
	}
}
